"use strict";

import anime from "animejs";

const stay_on_slide_time = 1800;

export default class {
  constructor({ slides, container }) {
    this.slides = slides;
    this.container = container;
    this.current = 0;
    this.state = "play"; // play|stop
  }

  get letters() {
    return this.slides[this.current].querySelectorAll(".letter");
  }

  get max() {
    return this.slides.length;
  }

  start() {
    this.appear()
      .finished.then(() => this.wait())
      .then(() => this.next())
      .catch(() => {});
  }

  hover(hovering) {
    hovering ? this.stop() : this.continue();
  }

  continue() {
    this.state = "play";
    this.wait()
      .then(() => this.loop(1))
      .catch(() => {});
  }

  stop() {
    this.state = "stop";
    clearTimeout(this.timer);
  }

  next(once = false) {
    clearTimeout(this.timer);
    this.loop(1, once);
  }

  prev(once = false) {
    clearTimeout(this.timer);
    this.loop(-1, once);
  }

  appear() {
    this.slides[this.current].classList.add("active");
    return anime({
      targets: this.letters,
      translateY: [-20, 0],
      translateZ: 0,
      opacity: [0, 1],
      duration: 500,
      easing: "easeInOutCubic",
      delay: (el, i) => 50 * i,
    });
  }

  disappear() {
    return anime({
      targets: this.letters,
      translateY: [0, 20],
      translateZ: 0,
      opacity: [1, 0],
      duration: 500,
      easing: "easeInOutCubic",
      delay: (el, i) => 50 * i,
    });
  }

  wait() {
    clearTimeout(this.timer);
    return new Promise((resolve, reject) => {
      this.timer = setTimeout(() => {
        this.state == "stop" ? reject() : resolve();
      }, stay_on_slide_time);
    });
  }

  loop(direction, once = false) {
    this.container.setAttribute("aria-live", once ? "polite" : "off");
    this.disappear()
      .finished.then(() => {
        this.slides[this.current].classList.remove("active");
        this.current =
          this.current + direction >= this.max
            ? 0
            : this.current + direction < 0
            ? this.max - 1
            : this.current + direction;

        return this.appear().finished;
      })
      .then(() => this.wait())
      .then(() => {
        if (!once) {
          this.next();
        } else this.stop();
      })
      .catch(() => {});
  }

  static separateWordsInLetters(words) {
    for (const word of words) {
      word.innerHTML = word.innerHTML.replace(
        /([a-zA-ZÀ-ÿ]|\w)/g,
        "<span class='letter'>$&</span>"
      );
    }
  }
}
